import React from 'react';
import Radium from 'radium';

import Dispatcher from 'service/Dispatcher';

class AlertMessageBox extends React.Component {
	clearMessageAlert() {
		Dispatcher.dispatchClearAlert();
	}

	render() {
		const message = this.props.message;

		if(message) {
			const messageType = message.type;

			const alertMessageClass = "alertMessage" + messageType.charAt(0).toUpperCase() + messageType.slice(1).toLowerCase();

			return (<div className={"alertMessage "+alertMessageClass}>
						{message["message"]}
						<i onClick={this.clearMessageAlert.bind(this)} className="fa fa-times alertMessageClose" aria-hidden="true" />
					</div>);
		}
		
		return null;
	}
}

AlertMessageBox = Radium(AlertMessageBox);

export default AlertMessageBox;



// WEBPACK FOOTER //
// ./src/views/AlertMessageBox.js